import { Injectable } from '@angular/core';
import { EntityType, JkEntityV2,jkLib,dateFormatter, AgComboBoxEditor, } from 'jk-service';
import { AgCheckBoxEditor, AgTextAreaEditor } from 'jk-service';
import { Syssf } from '../entity/Syssf-angular';

export interface SyssfData {     COMPANY: string ;     CREATOR: string;     USR_GROUP: string ;     CREATE_DATE: string;     MODIFIER: string;     MODI_DATE: string;     FLAG: number;     SF001: string;            // 改用ADMSA_程式代號 20 join ADMMB   改用ADMSA    SF002: string;            // 主程式名稱 40 EX:KM_STK.EXE    SF003: string;            // 程式型態 1 [DEF:"1"] 1:內部程式 2:外部DLL 3:主要EXE程式    SF004: string;            // DLL檔名 40     SF005: string;            // 備註 255 }


@Injectable({
  providedIn: 'root'
})
export class SyssfServicePkg extends JkEntityV2 { 


  constructor() {
    super();
    this.linkMasterFields = '' ; 
    this.defaultItem = new Syssf(); 
    this.entityType.type = EntityType.master;
    this.columnLabel = { COMPANY: '公司代號', CREATOR: '建檔者代號', USR_GROUP: '群組', CREATE_DATE: '建檔日期', MODIFIER: '修改者代號', MODI_DATE: '修改日期', FLAG: '更新次數', 
        SF001 : '改用ADMSA_程式代號' , SF002 : '主程式名稱' , SF003 : '程式型態' , SF004 : 'DLL檔名' , SF005 : '備註'  }; 

    this.fieldNames = 'SF001,SF002,SF003,SF004,SF005' ;
    this.fieldLengths = {SF001 : 20 ,SF002 : 40 ,SF003 : 1 ,SF004 : 40 ,SF005 : 255 } ;
    this.columnDefs = [
      { field: "SF001", headerName: "改用ADMSA_程式代號",headerTooltip: "",width:230,cellDataType: "text", },
      { field: "SF002", headerName: "主程式名稱",headerTooltip: "",width:250,cellDataType: "text", },
      { field: "SF003", headerName: "程式型態",headerTooltip: "",width:80,cellDataType: "text", },
      { field: "SF004", headerName: "DLL檔名",headerTooltip: "",width:250,cellDataType: "text", },
      { field: "SF005", headerName: "備註",headerTooltip: "",width:250,cellDataType: "text", cellEditor: 'agLargeTextCellEditor', cellRenderer: AgTextAreaEditor,  },
    ];
    this.columnDefsVir = [
    ];
    this.tableName = 'SYSSF' ;
    this.isSys =true; 
    this.sqlSelect = `SELECT SYSSF.*  FROM SYSSF` ;
    this.sqlWhereDefault = `/*WHERE*/ WHERE 1=1` ;
    this.sqlOrderDefault = ` ORDER BY SF001` ;
    this.keyFields = ['SF001'];
    this.url = '/db/crud'; 
    this.rememberFields = [];
    this.requiredFields = ['SF001'];
    this.seqField = '' ;
    this.seqFieldLength = 0 ;
  }
  override async validateItem(item: Syssf): Promise<boolean> {
    let bool = await super.validateItem(item);
    return bool;
  }

  override async newRecord(newItem:Syssf): Promise<Syssf> {
  await  super.newRecord(newItem);
    return newItem;
  }




}

